module.exports = __webpack_public_path__ + "static/canvas-craze-logo-removebg-1f7b9e65110cd6a42cba0741083943cc.webp";